import { wrapAsDerivedFromMeasurementsConfig as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getDerivedFromMeasurementsConfig = (prefix: string) => ({
  [`${prefix}.Preparation.TotalSampleWetMass`]: wrap([
    `${prefix}.Preparation.TareMass`,
    `${prefix}.Preparation.TareAndTotalSampleWetMass`,
  ]),
  [`${prefix}.Preparation.TotalSampleDryMass`]: wrap([
    `${prefix}.Preparation.TareMass`,
    `${prefix}.Preparation.TareAndTotalSampleWetMass`,
  ]),
  [`${prefix}.Preparation.DryMassRetained`]: wrap([
    `${prefix}.Preparation.TareMassRetained`,
    `${prefix}.Preparation.TareAndDryMassRetained`,
  ]),
});

export default getDerivedFromMeasurementsConfig;
